if (!customElements.get('printer-finder')) {
  customElements.define(
    'printer-finder',
    class PrinterFinder extends HTMLElement {
      connectedCallback() {
        this.brand = this.querySelector('[data-printer-brand]');
        this.model = this.querySelector('[data-printer-model]');
        this.query = this.querySelector('[data-printer-query]');
        this.submit = this.querySelector('[data-printer-submit]');
        this.form = this.querySelector('form');
        this.autoSubmitBrand = this.hasAttribute('data-brand-auto-submit');

        if (!this.brand || !this.model || !this.query || !this.submit || !this.form) return;

        this.brand.addEventListener('change', () => {
          const hasBrand = Boolean(this.getBrandValue());
          this.model.disabled = !hasBrand;
          if (!hasBrand) this.model.value = '';
          this.update();

          if (hasBrand && this.autoSubmitBrand) {
            const brandUrl = String(this.brand.dataset.url || '').trim();

            if (brandUrl) {
              window.location.assign(brandUrl);
            } else {
              this.form.requestSubmit();
            }
          } else if (hasBrand) {
            this.model.focus();
          }
        });

        this.model.addEventListener('input', () => this.update());
        this.form.addEventListener('submit', () => this.update());

        const hasInitialBrand = Boolean(this.getBrandValue());
        this.model.disabled = !hasInitialBrand;
        this.update();
      }

      getBrandValue() {
        return String(this.brand.value || this.brand.dataset.value || '').trim();
      }

      update() {
        const category = String(this.dataset.categorySearchTerm || '').trim();
        const brand = this.getBrandValue();
        const model = this.model.value.trim();
        const strictBrand = this.autoSubmitBrand && brand ? `title:"${brand.replaceAll('"', '')}"` : brand;
        this.query.value = [category, strictBrand, model].filter(Boolean).join(' ');
        this.submit.disabled = this.autoSubmitBrand ? !brand : !(brand && model);
      }
    },
  );
}

if (!customElements.get('category-brand-select')) {
  customElements.define(
    'category-brand-select',
    class CategoryBrandSelect extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;

        this.trigger = this.querySelector('[data-category-brand-trigger]');
        this.menu = this.querySelector('[data-category-brand-menu]');
        this.label = this.querySelector('[data-category-brand-label]');
        this.options = [...this.querySelectorAll('[data-category-brand-option]')];

        if (!this.trigger || !this.menu || !this.label || !this.options.length) return;

        this.initialized = true;
        this.trigger.addEventListener('click', () => this.toggle());
        this.options.forEach((option) => {
          option.addEventListener('click', () => this.select(option));
        });
        this.addEventListener('keydown', (event) => this.handleKeydown(event));
        this.handleOutsideClick = (event) => {
          if (!this.contains(event.target)) this.close();
        };
        document.addEventListener('click', this.handleOutsideClick);
      }

      disconnectedCallback() {
        document.removeEventListener('click', this.handleOutsideClick);
      }

      get value() {
        return this.dataset.value || '';
      }

      set value(value) {
        this.dataset.value = value;
      }

      toggle() {
        const willOpen = this.menu.hidden;
        this.menu.hidden = !willOpen;
        this.trigger.setAttribute('aria-expanded', String(willOpen));

        if (willOpen) this.options[0].focus();
      }

      close() {
        if (!this.menu || this.menu.hidden) return;
        this.menu.hidden = true;
        this.trigger.setAttribute('aria-expanded', 'false');
      }

      select(option) {
        const selectedValue = option.dataset.value || '';
        this.value = selectedValue;
        this.dataset.url = option.dataset.url || '';
        this.label.textContent = option.textContent.trim();
        this.options.forEach((item) => {
          item.setAttribute('aria-selected', String(item === option));
        });
        this.dispatchEvent(new Event('change', { bubbles: true }));
        this.close();
        this.trigger.focus();
      }

      handleKeydown(event) {
        if (event.key === 'Escape') {
          this.close();
          this.trigger.focus();
          return;
        }

        if (this.menu.hidden || !['ArrowDown', 'ArrowUp'].includes(event.key)) return;

        event.preventDefault();
        const currentIndex = this.options.indexOf(document.activeElement);
        const direction = event.key === 'ArrowDown' ? 1 : -1;
        const nextIndex = (currentIndex + direction + this.options.length) % this.options.length;
        this.options[nextIndex].focus();
      }
    },
  );
}

if (!customElements.get('category-brand-grid')) {
  customElements.define(
    'category-brand-grid',
    class CategoryBrandGrid extends HTMLElement {
      connectedCallback() {
        this.expandButtons = [...this.querySelectorAll('[data-category-brands-expand]')];
        this.extraBrands = [...this.querySelectorAll('.ps-category-card__extra')];

        this.expandButtons.forEach((button) => {
          button.addEventListener('click', () => this.expandAll());
        });
      }

      expandAll() {
        this.extraBrands.forEach((brand) => {
          brand.hidden = false;
        });

        this.expandButtons.forEach((button) => {
          button.setAttribute('aria-expanded', 'true');
          button.hidden = true;
        });
      }
    },
  );
}
